import {
  CaseReducer,
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import { Headers, GeneralInitialState } from "../types/RequestsTypes";
import { api } from "../api";
import { store } from "../store";

export const fetchTranslations = createAsyncThunk<any, string>(
  "translations",
  /** @param {string } locale */
  async (locale, thunkAPI) => {
    return await thunkAPI.dispatch(
      api.getTranslation.initiate(locale, { forceRefetch: true })
    );
  }
);

export const fetchInitData = createAsyncThunk<
  Omit<GeneralInitialState, "loading">
>("generalSettings", async (_, thunkAPI) => {
  try {
    const locale = store.getState().generalSettings.locale;
    const responseGeneralSettings = await thunkAPI.dispatch(
      api.getGeneralSettings.initiate("")
    );

    if (responseGeneralSettings.data) {
      await thunkAPI.dispatch(fetchTranslations(locale));
    }

    return {
      generalSettings: responseGeneralSettings.data,
    } as unknown as Omit<GeneralInitialState, "loading">;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

const headersReducer: CaseReducer<
  GeneralInitialState,
  PayloadAction<Headers>
> = (state, action) => {
  state.headers = action.payload;

  return state;
};

const localeReducer: CaseReducer<GeneralInitialState, PayloadAction<string>> = (
  state,
  action
) => {
  state.locale = action.payload;

  store.dispatch(api.getTranslation.initiate(action.payload));

  return state;
};

const general = createSlice({
  name: "generalSettings",
  initialState: {
    generalSettings: {},
    headers: null,
    loading: false as boolean,
    locale: "nb",
  } as GeneralInitialState,
  reducers: {
    setHeaders: headersReducer,
    setLocale: localeReducer,
  },
  extraReducers(builder) {
    builder.addCase(fetchInitData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchInitData.fulfilled, (state, action) => {
      state.generalSettings = action.payload.generalSettings;
    });
    builder.addCase(fetchTranslations.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTranslations.fulfilled, (state, action) => {
      state.locale = action.meta.arg;

      state.loading = false;
    });
  },
});

export const { setHeaders, setLocale } = general.actions;

export default general.reducer;
